import {
    SET_WELCOME,
} from "@/views/home/store/types/types.js";

const mutations = {
    [SET_WELCOME]: (state, payload) => state.welcome = payload,
};

export default mutations